export default __webpack_public_path__ + "static/drowdown-9df049fe689780bfc8a4fb52b853852c.png";